document.addEventListener('DOMContentLoaded', function(){

    if(document.querySelector('.grabday-products')){

        new Swiper('.grabday-products',{

            slidesPerView:4,

            spaceBetween:25,

            navigation:{
                nextEl:'.grabday-next',
                prevEl:'.grabday-prev'
            },

            breakpoints:{

                320:{
                    slidesPerView:1.2,
                    spaceBetween:15
                },

                768:{
                    slidesPerView:2.2,
                    spaceBetween:20
                },

                1024:{
                    slidesPerView:3
                },

                1400:{
                    slidesPerView:4
                }

            }

        });

    }

});